export default function assetTypeDirective() {
  return {
    template: require('./asset-type.html'),
    restrict: 'E',
    controller: 'AssetTypeController',
    controllerAs: 'assetTypeVM',
    bindToController: true,
    replace: true,
    scope: {
      assetType: '=',
      tooltipAppendToSelector: '@',
      riskCount: '<'
    },
  };
}
